import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import {
	BorderLine,
	ColorTitle,
	OptionWrapper,
} from '../../../FilterOptonsModal.styled';
import { MATCH_TYPE_OPTIONS } from '../../../constants/matchTypeOptions';

export const FilterOptionFinderStringAdvanced = ({
	fieldData,
	filters,
	dispatchFilters,
}) => {
	const currentFilter = filters[fieldData.label] || {};
	const textValue = currentFilter.value || '';

	const currentMatchType =
		MATCH_TYPE_OPTIONS.find((opt) => opt.value === currentFilter.match_type) ||
		MATCH_TYPE_OPTIONS[0];

	const handleTextChange = (text) => {
		if (text.length > 0) {
			dispatchFilters({
				type: 'add',
				key: fieldData.label,
				value: text,
				type_field: 'String',
				match_type: currentMatchType.value,
			});
		} else {
			dispatchFilters({
				type: 'remove',
				key: fieldData.label,
			});
		}
	};

	const handleMatchTypeChange = (selectedOption) => {
		if (textValue.length > 0) {
			dispatchFilters({
				type: 'add',
				key: fieldData.label,
				value: textValue,
				type_field: 'String',
				match_type: selectedOption.value,
			});
		}
	};

	return (
		<OptionWrapper>
			<ColorTitle>{fieldData.label}:</ColorTitle>
			<BorderLine />
			<SelectInput
				name='Match Type'
				showLabel={false}
				options={MATCH_TYPE_OPTIONS}
				selected={currentMatchType}
				setSelected={handleMatchTypeChange}
				width={150}
				selectWidth={140}
				placeholder='Match Type'
			/>
			<Input
				showLabel={false}
				value={textValue}
				onChange={(e) => handleTextChange(e.target.value)}
			/>
		</OptionWrapper>
	);
};
